export namespace TimeUtils{
    export function sleep(ms: number) {
        console.log('PopOutController: sleep');
        return new Promise(resolve => setTimeout(resolve, ms));
      }
}